import { render, staticRenderFns } from "./RoelandCard.vue?vue&type=template&id=dad904ce&"
import script from "./RoelandCard.vue?vue&type=script&lang=js&"
export * from "./RoelandCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports